import React from 'react';
import { compose } from '@beef/utils';
import { withRenderFlag } from '@beef/react';
import { connect } from 'react-redux';
import { ActionBar, Button } from '@beef/ui-kit';

// selectors

import { getActiveButtonText, getButtonDisabledStatus, getButtonLoadingStatus, getSecondButtonText, getUserAgreementText, shouldRenderModalButton, shouldRenderSecondButton } from "../../../store/selectors/modal";
var _ModalActionBar = function _ModalActionBar(_ref) {
  var buttonText = _ref.buttonText,
    isLoading = _ref.isLoading,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    onSecondaryButtonClick = _ref.onSecondaryButtonClick,
    isShowSecondaryButton = _ref.isShowSecondaryButton,
    secondaryButtonText = _ref.secondaryButtonText;
  return /*#__PURE__*/React.createElement(ActionBar, {
    size: "m",
    "data-t-id": "OrderTariffControl-ModalActionBar"
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    isLoading: isLoading,
    onClick: onClick,
    "data-t-id": "OrderTariffControl-ModalActionBar"
  }, buttonText), isShowSecondaryButton && /*#__PURE__*/React.createElement(Button, {
    onClick: onSecondaryButtonClick,
    variant: "tertiary"
  }, secondaryButtonText));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    buttonText: getActiveButtonText(state),
    secondaryButtonText: getSecondButtonText(state),
    isLoading: getButtonLoadingStatus(state),
    disabled: getButtonDisabledStatus(state),
    userAgreement: getUserAgreementText(state),
    shouldRender: shouldRenderModalButton(state),
    isShowSecondaryButton: shouldRenderSecondButton(state)
  };
};
var connector = connect(mapStateToProps);
export var ModalActionBar = compose(connector, withRenderFlag)(_ModalActionBar);